import { createAction } from 'redux-api-middleware'

import { HUBBLE_API_TOKEN } from '../../../store/middleware/APIUrl'

const Types = {
    DEVICE_HISTORY_FETCH: {
        request: 'DEVICE_HISTORY_FETCH##REQUEST',
        success: 'DEVICE_HISTORY_FETCH##SUCCESS',
        failure: 'DEVICE_HISTORY_FETCH##FAILURE',
    },
}

/**
 * Fetch a device history
 * @param {String} device Device ID
 */
function fetchDeviceHistory(device) {
    return createAction({
        endpoint: `${HUBBLE_API_TOKEN}/devices/${device}/history`,
        method: 'GET',
        types: [Types.DEVICE_HISTORY_FETCH.request, Types.DEVICE_HISTORY_FETCH.success, Types.DEVICE_HISTORY_FETCH.failure],
    })
}

export { Types, fetchDeviceHistory }
